let ZaloLoginBtn
if (process?.env?.REACT_APP_CORDOVA) {
  ZaloLoginBtn = require('./ZaloLoginBtn.cordova.js').default
} else {
  ZaloLoginBtn = require('./ZaloLoginBtn.js').default
}
export default ZaloLoginBtn